var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Loader } from "./Loader";
var LoaderText = /** @class */ (function (_super) {
    __extends(LoaderText, _super);
    function LoaderText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LoaderText.prototype.render = function () {
        return (React.createElement("div", { className: "rj-loader-with-text" },
            React.createElement(Loader, null),
            React.createElement("div", { className: "rj-loader-text" }, this.props.text)));
    };
    return LoaderText;
}(React.PureComponent));
export { LoaderText };
//# sourceMappingURL=LoaderText.js.map